import axios from "../api";
import { objectToParam } from "../../libs/utils";
import {CrewMember, QueryListResult} from "../../hooks/api/utils/types";

export async function getRegistrationCrewMembers(registrationId: number, params = {}): Promise<QueryListResult<CrewMember>> {
  const parameters = objectToParam(params);

  const { data } = await axios.get(
    `registrations/${registrationId}/crew-members?${parameters}`
  );

  return data;
}
